import * as React from 'react';
import { Guid } from '../../infrastructure/Guid';

export interface TabsProps {
    columns: Map<number, string>;
    children: any;
    defaultColumnKey: number;
    onTabChanged?: (selectedKey: number) => void;
    isLaererSkrivebord?: boolean;
}

class Tabs extends React.Component<TabsProps, any> {
    prefix: string;

    constructor(props: TabsProps) {
        super(props);
        this.getTabs = this.getTabs.bind(this);
        this.prefix = Guid.newGuid();
    }

    onChange(key: number) {
        if (this.props.onTabChanged !== undefined) {
            this.props.onTabChanged(key);
        }
    }

    getTabs() {
        var self = this;
        var columns = Array<any>();
        this.props.columns.forEach(function (value: string, key: number, map: any) {
            let className = '';

            if (self.props.defaultColumnKey === key) {
                className = 'active';
            }

            columns.push(
                <li key={key} role='presentation' className={className}>
                    <a href={'#' + key} aria-controls={key.toString()} role='tab' data-toggle='tab' onClick={() => self.onChange(key)}>{value}</a>
                </li>
            );
        });

        return columns;
    }

    getTabContentClasses() {
        var classes = 'tab-content';
        if (this.props.isLaererSkrivebord === undefined || !this.props.isLaererSkrivebord) {
            classes += ' container';
        }

        return classes;
    }

    render() {
        return (
            <div className='tabs'>
                <div className='tabcolumns'>
                    <ul className='nav nav-tabs container' role='tablist'>
                        {this.getTabs()}
                    </ul>
                </div>

                <div className={this.getTabContentClasses()}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Tabs;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/Tabs.tsx